import {
	RECEIVE_BAD_REQUEST_BREACH_CAUSATION_CP, RECEIVE_BREACH_CAUSATION_CP,
	REQUEST_BREACH_CAUSATION_CP
} from "../actions/index";
const defaultState = {
	options: [],
	fetching: false,
	badFetchResponse: ''
};

export default (state = defaultState, action) => {
	switch (action.type) {
		case REQUEST_BREACH_CAUSATION_CP:
			return {
				...state,
				fetching: true
			};
		case RECEIVE_BREACH_CAUSATION_CP:
			return {
				...state,
				fetching: false,
				options: action.payload
			};
		case RECEIVE_BAD_REQUEST_BREACH_CAUSATION_CP:
			return {
				...state,
				fetching: false,
				badFetchResponse:action.payload
			};
		default:
			return state
	}
}


